// tslint:disable:max-line-length
export default {
  banner: {
    notice: 'Notice: ',
    text:
      'If you require immediate attention and this is an emergency, please dial '
  },
  contact: {
    contactInfo: {
      feedback: {
        action:
          'or to get access to a patient representative, call our toll-free Care to Share telephone line: ',
        feedbackCare: ' feedback about your care ',
        phone: '1-855-657-4273',
        shareFeedback: 'Share feedback about your care or get access to a patient representative on our Care to Share line',
        toShare: 'To share',
      },
      general: {
        for: 'For ',
        forInfo: 'General information about Lancaster General Health',
        info: 'general information',
        phone: '1-888-544-4636',
        rest: ' about Lancaster General Health, call ',
      },
      switchboard: {
        call: ' call ',
        description: '24-hour switchboard,',
        phone: '717-544-5511',
        reach: 'To reach our ',
        toReach: '24-hour phone directory'
      },
      technical: {
        for: 'For technical support for the ',
        forTech: 'Technical support for the MyLGHealth patient portal',
        lghHealth: 'MyLGHealth',
        number: ' patient portal, call ',
        phone: '717-544-2860',
      }
    },
    headers: {
      contact: 'Contact Us',
      feedback: 'Provide Feedback'
    }
  },
  emergencyDepartment: {
    address: 'Address:',
    getDirections: 'Get Directions',
    header: 'LGH Emergency Department',
    phone: 'Phone:',
    subheader: 'Below is information for our main emergency department'
  },
  external: {
    redirect: 'You are about to be redirected to the {{loc}} site.',
    scheduling: 'scheduling'
  },
  feedback: {
    copy:
      'Please use the form below to offer feedback on the “Where do I go for care” app.'
  },
  general: {
    high: 'High',
    low: 'Low',
    medium: 'Medium',
    no: 'No',
    yes: 'Yes'
  },
  landingPage: {
    banner: {
      bone: 'Bone protruding through skin',
      call: 'Call ',
      chest: 'Chest Pain',
      cough: 'Coughing up blood',
      difficulty: 'Difficulty breathing',
      emergencyDepartment:
        'or visit the nearest Emergency Department if you\'re experiencing:',
      number: '911',
      vomit: 'Vomiting blood'
    },
    checkSymptoms: 'Enter Your Symptoms',
    header: 'Where do I go for care?',
    schedule: 'Schedule an Appointment',
    subheader:
      'This simple tool can help you find the most appropriate Lancaster General Health location based on your symptoms.'
  },
  link: {
    previous: 'Go back to previous page'
  },
  menu: {
    contact: 'Contact Us',
    emergencyDepartment: {
      title: 'Emergency Department'
    },
    feedback: 'Provide Feedback',
    general: 'Contact & Location Information',
    home: 'Home',
    mainTitle: 'Where do I go for care?',
    primaryAndSpecialty: 'Primary & Specialty Care Locations',
    primaryCare: {
      locText: 'Primary Care',
      title: 'Primary Care'
    },
    scheduling: 'Scheduling',
    specialtyCare: {
      locText: 'Specialty Care',
      title: 'Specialty Care'
    },
    symptomChecker: 'Enter Your Symptoms',
    testing: {
      locText: 'Testing & Screening',
      title: 'Testing & Screening'
    },
    urgentCare: {
      locText: 'Urgent Care',
      title: 'Urgent Care'
    }
  },
  multiInput: {
    text: 'ex. headache, sore throat, fever'
  },
  painSlider: {
    levels: {
      mild: 'Mild Pain',
      none: 'No Pain',
      severe: 'Severe Pain',
      worst: 'Worst Possible Pain'
    }
  },
  results: {
    basedResponses: 'Based on your responses ',
    disclaimer: 'DISCLAIMER:',
    disclaimerText:
      ' This tool is designed to help you decide where to seek professional medical advice.  The tool uses the results from symptoms you have just entered.  This is just a suggestion of where you should go now and should not be relied on over and above your own instinct and judgement.',
    emergencyDepartment: {
      button: 'Emergency Department',
      emergencyNumber: '9-1-1',
      header: 'Emergency Department',
      mainHeader: 'Other Care Options',
      textAfter:
        ' if you experience chest pain, difficulty breathing, severe abdominal pain, severe fracture or burn, head injury or blurry vision, or other life threatening injuries or illnesses.',
      textBefore: 'Visit the nearest Emergency Department or call '
    },
    header: 'Recommended Care',
    modify: 'Modify My Responses',
    onDemand: {
      button: 'OnDemand',
      header: 'Penn Medicine OnDemand',
      text:
        'Feeling sick and want to stay home? Schedule a video visit with a Penn Medicine provider. Use a video-enabled device like an iPhone, iPad or Android mobile phone or tablet.'
    },
    pleaseNote: 'Please note the following symptoms were not included:',
    primaryCare: {
      button: 'Schedule Primary Care',
      header: 'Primary Care',
      text:
        'Visit a primary care provider when you’re not feeling well, have a minor injury or need a wellness check-up.'
    },
    recommended: ' the following options are recommended: ',
    startOver: 'Start Over',
    urgentCare: {
      button: 'Reserve My Spot',
      header: 'Urgent Care',
      text:
        'When your doctor’s not available, visit Urgent Care for treatment of minor illnesses and injuries.'
    }
  },
  symptomChecker: {
    basicSection: {
      dateOfBirth: 'Date of Birth',
      gender: {
        label: 'Sex at Birth'
      },
      header: 'Basic Information',
      symptoms: 'Enter and select your symptoms'
    },
    callPhysician:
      'Call your primary care physician to discuss the best location for care.  If you do not have a primary care physician, you should go to the nearest Emergency Department.',
    datepicker: {
      infantUnderAYear: 'Message for infants under one year.',
      invalidDate: 'Please enter a date in the past.',
      invalidDateFormat: 'Please enter a valid date.',
      invalidPastDate:
        'Please enter a date within 120 years of the current date.'
    },
    header: 'Enter Your Symptoms',
    requiredField: '* = Required Field',
    resetForm: 'Reset Form',
    severitySection: {
      change: {
        label: 'How have your symptoms changed over the last few hours/days?',
        options: {
          better: 'Better',
          same: 'Same',
          worse: 'Worse'
        }
      },
      dailyActivities: {
        label: 'How are your symptoms affecting your daily activities?',
        options: {
          none: 'No effect',
          struggle: 'Struggling to carry out usual activities',
          unable: 'Unable to carry out usual activities'
        }
      },
      discomfort: {
        label: 'How much pain or discomfort are you in?'
      },
      header: 'Severity Level',
      length: {
        label: 'How long have you had your symptoms?',
        options: {
          days: '0 - 6 Days',
          months: 'Months',
          weeks: 'Weeks'
        }
      },
      medication: {
        label: 'Do you feel better after taking medication for your symptoms?',
        options: {
          notTaking: 'Not taking any'
        }
      },
      otherConditions: {
        label:
          'Do you have any other serious, long term conditions such as diabetes, cancer, heart condition, etc.?'
      },
      quickness: {
        label: 'How quickly did your symptoms develop?',
        options: {
          days: 'Over Days',
          minutes: 'Over Minutes / Hours',
          months: 'Over Months',
          weeks: 'Over Weeks'
        }
      }
    },
    showResults: 'Show Results',
    subheader:
      'Within minutes, this simple tool can help you find the most appropriate Lancaster General Health location based on your symptoms.'
  },
  urgentCare: {
    header: {
      copy: 'Please use the search below or enable your geolocation settings to find our closest urgent care facility',
      title: 'Urgent Care',
    }
  },
};



// WEBPACK FOOTER //
// ./src/locales/en.ts